import { useMock } from '@nvision/services/mock';

// @ts-expect-error
// Temporary workaround for switching mock data
window.useMock = (isTrue = true) => {
  useMock(isTrue);
  location.reload();
};
